export const strings = {
  en: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
  fr: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
  de: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
  es: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
  it: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
  pl: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
  ja: {
    changeNonprofitButton: () => `Change Nonprofit`,
    previousImpactHeader: () => `Your Previous Impact`,
    previousNonprofitButton: () => `Back to Previous Nonprofit`,
    supportAgainButton: () => `Support Again`,
    via: () => `via`,
    showAllButton: () => `Show All`,
    showLessButton: () => `Show Less`,
  },
};
